import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export const Hero = ({ t }) => {
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-screen flex items-end noise-overlay">
      <div className="absolute inset-0">
        <img
          src="https://images.pexels.com/photos/35138560/pexels-photo-35138560.jpeg?auto=compress&cs=tinysrgb&w=1920"
          alt="Exhibition hall"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#08080a] via-[#08080a]/70 to-[#08080a]/40" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full pb-20 pt-40">
        <h1 data-testid="hero-title" className="font-display font-bold text-5xl md:text-7xl lg:text-8xl tracking-tight leading-[0.95] text-white max-w-4xl">
          <motion.span
            className="block"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            {t.hero.title1}
          </motion.span>
          <motion.span
            className="block"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.25 }}
          >
            {t.hero.title2}
          </motion.span>
          <motion.span
            className="block text-pink-brand italic"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            {t.hero.title3}
          </motion.span>
        </h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.55 }}
          data-testid="hero-subtitle"
          className="mt-8 max-w-xl text-base md:text-lg text-neutral-300 leading-relaxed"
        >
          {t.hero.sub}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.7 }}
          className="mt-10 flex flex-wrap gap-4"
        >
          <a
            href="#kontakt"
            data-testid="hero-cta-contact"
            className="group inline-flex items-center gap-3 bg-pink-brand text-white font-mono-accent text-xs uppercase tracking-[0.2em] px-8 py-4 hover:bg-[#d6008 5] hover:brightness-110 transition-[background-color,filter] duration-200"
          >
            {t.hero.cta1}
            <ArrowRight size={16} className="transition-transform duration-200 group-hover:translate-x-1" />
          </a>
          <a
            href="#projekte"
            data-testid="hero-cta-projects"
            className="inline-flex items-center gap-3 border border-white/30 text-white font-mono-accent text-xs uppercase tracking-[0.2em] px-8 py-4 hover:border-pink-brand hover:text-pink-brand transition-colors duration-200"
          >
            {t.hero.cta2}
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.9 }}
          className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-2xl border-t border-white/10 pt-8"
          data-testid="hero-stats"
        >
          {[ 
            [t.hero.stat1, t.hero.stat1Label],
            [t.hero.stat2, t.hero.stat2Label],
            [t.hero.stat3, t.hero.stat3Label],
          ].map(([v, l], i) => (
            <div key={i} className="flex flex-col h-full">
              <div className="font-display text-3xl md:text-4xl font-bold text-white">{v}</div>
              <div className="font-mono-accent text-[10px] md:text-xs uppercase tracking-[0.15em] text-neutral-500 mt-auto pt-1">{l}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
